import { useContext, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { ToolsContext, ToolsDispatchContext, mainToolset } from "../../ToolsContext";
import { useNewGtfsResource, useNewGtfsRoute } from "../../Queries";
import { useGtfsSuggestNewId } from "../../Queries";
import { OverlayContext } from "../../OverlaysContext";
import { NewCalendarForm } from "./NewCalendarForm";
import { gtfsFormatDateToYYYYMMDD } from "../../helpers/gtfsDateUtils";

export function NewCalendarDialog({visible, onHide}) {
    const {status: defaultIdStatus, data: defaultId} = useGtfsSuggestNewId('calendars');  
    const toolDispatch = useContext(ToolsDispatchContext);
    const handleOverlay = useContext(OverlayContext);  
    const newCalendarMutation = useNewGtfsResource('calendars');
    const [values, setValues] = useState({
        service_id: '',
        start_date: null,
        end_date: null,
        validation_errors: {
            route_id: false,
        }
    });

    const dialogFooterContent = (
        <div>
            <Button label="Anuluj" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            <Button label="OK" icon="pi pi-check" onClick={() => {handleSendData()}} autoFocus />
        </div>
    );

    function handleChangeID(e) {
        setValues({...values, service_id: e.target.value});
    }

    function handleChangeDateRange(e) {
        setValues({...values, start_date: e.value[0], end_date: e.value[1]});
    }


    async function handleSendData() {
        const data = {
          fields: {
            service_id: (values.service_id) ? values.service_id : defaultId,
            start_date: gtfsFormatDateToYYYYMMDD(values.start_date),
            end_date: gtfsFormatDateToYYYYMMDD(values.end_date),
            exceptions_dates_added: [],
            exceptions_dates_removed: []
          }
        }
    
        try {
          const mutation = await newCalendarMutation.mutateAsync(data);
          onHide();
          // po udanym dodaniu przystanku otwórz go w edytorze
          toolDispatch({
            type: 'changed',
            newTool: {
              ...mainToolset.tools.calendarsTool,
              selection: data.fields, // zaznacz kalendarz
              propertyEditor: {   // i wyświetl w edytorze
                ...data.fields
              }
            },
          });
          
        } catch(error) {
          const errorCode = error.message.slice(0,3);  
          if(errorCode == '422') {
            //obsługa błędów walidacji
            let updatedValidationErrors = {};
            let propertyNames = Object.keys(error.cause.validation);
            propertyNames.forEach((value) => {
              messages = Object.values(error.cause.validation[value]).join(', ');
              updatedValidationErrors[value] = messages;
            })
            setValues({
              ...values,
              validation_errors: {
                ...updatedValidationErrors
              }
            })
          } else {
            //obsługa wszystkich pozostałych błędów
            handleOverlay('toast', {
              severity: "error",
              summary: 'Błąd ' + errorCode,
              detail: error.message
            })
          } 
        }   
      }    

    return (
        <Dialog header="Nowy kalendarz" 
                footer={dialogFooterContent} 
                visible={visible} 
                style={{ width: '50vw', maxWidth: '500px' }}  
                breakpoints={{ '960px': '75vw', '641px': '100vw' }} 
                onHide={onHide}
        >
            <div className="m-0">
                {
                (defaultIdStatus === 'success' || defaultIdStatus === 'error') 
                ? 
                    <NewCalendarForm 
                        values={{
                            ...values,
                            service_id: (values.service_id) ? values.service_id : defaultId,
                        }} 
                        onChangeServiceId={handleChangeID} 
                        onChangeDateRange={handleChangeDateRange}
                    /> 
                : 
                    <ProgressSpinner />
                }
            </div>
        </Dialog>
    )
}